module.exports = __webpack_public_path__ + "static/Flavor-German-Amarillo-T45-VA18000296-dfeaaaea344ad0c9b89ee16b3d82141f.pdf";